export default "__VITE_ASSET__cb03e8ec__"